
  var _styles = {
  "activity-banner": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "width": "9.36rem",
    "height": "1.33333rem",
    "borderRadius": "0.24rem",
    "paddingLeft": "0.32rem",
    "paddingRight": "0.32rem",
    "position": "relative"
  },
  "activity-banner__background": {
    "position": "absolute",
    "top": "0.02667rem",
    "left": "0.02667rem",
    "width": "9.30667rem",
    "height": "1.28rem",
    "borderRadius": "0.24rem",
    "zIndex": 0
  },
  "activity-banner__content": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "position": "relative",
    "zIndex": 1
  },
  "activity-banner__icon": {
    "width": "0.8rem",
    "height": "0.8rem",
    "marginRight": "0.16rem"
  },
  "activity-banner__text": {
    "fontSize": "0.42667rem",
    "fontWeight": "500",
    "color": "rgb(0,0,0)",
    "fontFamily": "PingFang SC"
  },
  "activity-banner__button": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "1.6rem",
    "height": "0.8rem",
    "borderRadius": "1.22667rem",
    "backgroundColor": "rgb(255,237,75)",
    "position": "relative",
    "zIndex": 1
  },
  "activity-banner__button-text": {
    "fontSize": "0.32rem",
    "fontWeight": "600",
    "color": "rgb(0,0,0)",
    "fontFamily": "PingFang SC"
  }
};



  module.exports = _styles;
  